import { GridColumns, GridRows } from '@visx/grid';
import { QUALITY_TIMELINE } from '../../consts';
import { TimelineAxisTop } from '../axis/TimelineAxisTop';
import { TimelineChartXScale, TimelineChartYScale } from '../lib/timeline-chart-scale-types';

export type TimelineChartGridAndAxisProps = {
  xScale: TimelineChartXScale;
  yScale: TimelineChartYScale;
  innerWidth: number;
  innerHeight: number;
  stationIds: string[];
  includeTopAxis: boolean;
};

/**
 * Background grid and optional top time axis inside the chart plot group.
 */
export function TimelineChartGridAndAxis({
  xScale,
  yScale,
  innerWidth,
  innerHeight,
  stationIds,
  includeTopAxis,
}: TimelineChartGridAndAxisProps) {
  return (
    <>
      <GridRows
        scale={yScale}
        width={innerWidth}
        stroke={QUALITY_TIMELINE.chartColors.grid}
        strokeOpacity={0.6}
        tickValues={stationIds}
      />
      <GridColumns
        scale={xScale}
        height={innerHeight}
        stroke={QUALITY_TIMELINE.chartColors.grid}
        strokeOpacity={0.6}
      />
      {includeTopAxis ? (
        <TimelineAxisTop
          scale={xScale}
          stroke={QUALITY_TIMELINE.chartColors.grid}
          tickStroke={QUALITY_TIMELINE.chartColors.grid}
          tickLabelFill={QUALITY_TIMELINE.chartColors.axisTick}
        />
      ) : null}
    </>
  );
}
